// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__fyY6l","bannerLink":"Banner_bannerLink__32YkZ"};